import { useState, useEffect } from "react";
import axios from "axios";
import { api_v3_list_of_tournaments } from "../utils/constants";

export const useTournamentData = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [tournaments, setTournaments] = useState([]);
  const [selectedTournamentId, setSelectedTournamentId] = useState(null);

  useEffect(() => {
    const loadTournaments = async () => {
      setLoading(true);
      try {
        const response = await axios.get(api_v3_list_of_tournaments());
        if (response.status === 200) {
          setTournaments(response.data);
          setSelectedTournamentId(
            response.data[response.data.length - 1]?.tournamentId || ""
          );
        } else {
          setError(true);
        }
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadTournaments();
  }, []);

  return {
    loading,
    error,
    tournaments,
    selectedTournamentId,
    setSelectedTournamentId,
  };
};
